import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgActionUpload = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#2D2E2E"
      d="M6 10.73v2.61l5-4.2V19h2V9.14l5 4.2v-2.61l-6-5-6 5ZM21 4V2H3v2h18Z"
    />
  </svg>
);
export default SvgActionUpload;
